<div class="row">
  <div class="col-md-12">

    <div style="position: absolute; top: 1px; right: 0px; z-index: 99999; cursor: pointer;" mat-button (click)="close()" class="" cdkFocusInitial>
      <i class="material-icons">close</i>
    </div>

    <div class="card" style="height: auto;">

      <div class="card-header card-header-icon card-header-rose">
        <div class="card-icon">
          <i class="material-icons">zoom_in</i>
        </div>
        <h4 class="card-title">Search Master Item</h4>
      </div>

      <div class="card-body">
        <div mat-dialog-content>


           <div class="toolbar">

          <div class="row">
            <div style="display: grid;" class="col-md-12">
              <mat-form-field class="example-full-width">
                <mat-label>Item</mat-label>
                <input matInput placeholder="Type your search here" name="filter" [(ngModel)]="filteritem">
              </mat-form-field>
           
             
                <button class="btn btn-info btn-sm" (click)="getData()">
                  <i class="material-icons">search</i> Search
                </button>
              </div>

           
          </div>
        </div>

          <div *ngIf="loading" style="text-align: center">
            <h2><b><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> Loading...</b></h2>
          </div>
          <div *ngIf="show_no_data" class="alert alert-warning">
            No results match your search criteria, please try again.
          </div>
        

      
          <br><hr>
          <div *ngIf="!loading && dataInFo.rows.length > 0" class="row">
            <div class="col-12">
           
            <dinamic-table 
            *ngIf="!loading" 
            [id]="'searchmasteritem'" 
            [data]="dataInFo" 
            [btnCol]="false" 
            [frontpaginate]="true" 
            (action_button)="actions($event)" 
            ></dinamic-table>
            </div>
          </div>

        </div>
      </div>

    </div>

    <div class="row">
      <div class="col-md-6">
        <button (click)="close()" class="btn btn-default">Close</button>
      </div>
      <div class="col-md-6" style="text-align: right;">
        <!-- <button *ngIf="!edit" (click)="edit = true" class="btn btn-warning">
          <i class="fa fa-pencil" aria-hidden="true"></i> &nbsp; Edit
        </button> -->
        <!-- <button *ngIf="edit" (click)="save()" class="btn btn-primary" [disabled]="!f.valid || saving || loading">
          <i *ngIf="!saving" class="fa fa-floppy-o" aria-hidden="true"></i>
          <i *ngIf="saving" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
          &nbsp; Save
        </button> -->
      </div>
    </div>

  </div>
</div>

